import { Close } from 'uiKit/atoms/Close/Close';
import cn from 'classnames';
import styles from '../Modal/Modal.module.scss';
import { IconButton } from 'uiKit/atoms/IconButton/IconButton';

import { Box } from 'uiKit/atoms/Box/Box';
import { Typography } from 'uiKit/atoms/Typography/Typography';

type HeaderProps = {
  title?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
  onClose?: () => void;
};

export const Header = ({ title, className, children, onClose }: HeaderProps) => {
  return (
    <Box className={cn(styles.modal__header, className)}>
      {children ? <>{children}</> : <Typography variant="h5">{title}</Typography>}
      {onClose && (
        <IconButton data-testid="base-modal-close-btn" onClick={onClose} aria-label="close" size="small">
          <Close />
        </IconButton>
      )}
    </Box>
  );
};
